export const Urls = {
    BaseURL: 'cdn-base-url',
    Domain: 'https://www.myvirtualwallet.co.uk',

    // Page ids
    vwHomepage: '93',
    vwHomepageTwo: '113',

    vwProductOne: '92',
    vwProductTwo: '100',
    vwProductThree: '101',
    
    vwMicroCommisioning: '162',
    addProvider: '141',
    myProviders: '142',
    myPrograms: '143',
    agencyEnrolments: '37',
    myDesignatedRep: '144',
    mySignatures: '145',
    addDesignatedRep: '146',
    myDetails: '148',
    myParticipants: '149',
    servicesAndRates: '154',
    myDocuments: '256',
    fundingDue: '261',
    providerTimesheetsAdmin: '293',
    personalTimesheets: '297',

    mainDashboard: '150',
    vwSagDash: '151',

    searchShopEquipment: '168',
    searchShopServices: '169',
    searchMyCatalogue: '170',
    searchShopStores: '171',

    manualPayment: '205',
    managePayee: '206',
    paymentTransfer: '207',
    providerDetails: '211',
    manualTransactionPayments: '221',

    vwLitePageId: '178',
    vwLiteProductId: '195',

    pplConnectPage: '311',
    pa_vacancySearchPage: '312',
    pplChat: '313',
    reportsPage: '347',
    
    vwliteCouncil: 'NHS Hull CCG',

    manualTransactionPaymentApproval: '221',

    //incrementsAttribute: 'VWLite Increments',
    // incrementsAttribute: 'LBBD Increments',
    incrementsAttribute: 'Increments',

    // Attributes
    allowSelfServicePayment: 'c4081c76-9a24-4cc1-8e7f-aeec00fad56c',

    // Form ids
    form_nwl: '971',
    form_essex: '823',
    form_croydon: '824',
    form_bucks: '825',
    form_powys: '850',
    form_CheshireCCG: '972',
    form_vwLite: '967',
    form_lincs: '1037',
    form_hull: '967',
    form_devon: '1016',
    form_dorset: '1017',
    form_wiltshire: '1024',
    form_kentMedway: '1025',
    attachments_appForm: '645289962a39462df7500db4',
    
    virtualWalletLiteSecurityGroup: 'bb6cf2af-029a-4cc6-b81b-ae4700ca4ff4',
    providerDetailsSecurityGroup: 'd3565417-134a-46c5-ac34-ab4c00a1b939',
    addPayeeSecurityGroup: '1c2d283f-0a85-4054-80fa-b00b01229ce5',
    approverSecurityGroup: '3d77e404-6da7-40c6-bd36-b02300e40c4d',
    readOnlySecurityGroup: 'e8bc9297-105c-4ec4-b6f2-b1b60113df5e',

    manualTransactionSecurityGroups: {
        mt_Payment: '1f181521-7821-47ca-b97a-afa400bb0ab4',
        mt_Repeating: '14077b13-5a1b-46a4-91de-afa400c174ba',
        mt_attachment: '9d0b965f-f2e3-48c7-8577-af8f00e8fa1a'
    },

    permission: {
        manualTransactionPayments: '8ac87b59-4ccf-4ded-b779-8343341ef198'
    },

    // Devon marketplaces
    devonMarketplace: '52ec69f6-9a12-40a6-81bd-b10101686083'
}